import type { LinkObject } from '3d-force-graph';
import { GalaxyNode, GalaxyNodeType } from './galaxy-node';

export enum GalaxyLinkType {
  ORIGIN_TO_SPIRAL = 'origin_to_spiral',
  SPIRAL_TO_CLUSTER = 'spiral_to_cluster',
  CLUSTER_TO_STAR = 'cluster_to_star',
  STAR_TO_PLANET = 'star_to_planet',
}

export class GalaxyLink implements LinkObject<GalaxyNode> {
  id: string;
  source: GalaxyNode;
  target: GalaxyNode;
  type: GalaxyLinkType;

  constructor(source: GalaxyNode, target: GalaxyNode, type: GalaxyLinkType) {
    this.id = `${source.id}_${target.id}_${type}`;
    this.source = source;
    this.target = target;
    this.type = type;
  }

  static determineType(sourceType: GalaxyNodeType, targetType: GalaxyNodeType): GalaxyLinkType | null {
    if (sourceType === GalaxyNodeType.ORIGIN && targetType === GalaxyNodeType.SPIRAL) {
      return GalaxyLinkType.ORIGIN_TO_SPIRAL;
    }
    if (sourceType === GalaxyNodeType.SPIRAL && targetType === GalaxyNodeType.CLUSTER) {
      return GalaxyLinkType.SPIRAL_TO_CLUSTER;
    }
    if (sourceType === GalaxyNodeType.CLUSTER && targetType === GalaxyNodeType.STAR) {
      return GalaxyLinkType.CLUSTER_TO_STAR;
    }
    if (sourceType === GalaxyNodeType.STAR && targetType === GalaxyNodeType.PLANET) {
      return GalaxyLinkType.STAR_TO_PLANET;
    }
    return null;
  }

  static isValidLink(sourceType: GalaxyNodeType, targetType: GalaxyNodeType): boolean {
    return this.determineType(sourceType, targetType) !== null;
  }
}
